module.exports = __webpack_public_path__ + "img/alert-icon.a48fc4d9.svg";